import { formatDate } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { URL_SERVICIOS } from 'src/app/config/config';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { FichaMedicaService } from 'src/app/services/ficha-medica.service';
import { MedicosService } from 'src/app/services/medicos.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import Swal from 'sweetalert2';
import { ScheduleService } from '../../services/schedule.service';
import { OndemandSocketService } from 'src/app/services/ondemand-socket.service';

@Component({
  selector: 'app-salaespera',
  templateUrl: './salaespera.component.html',
  styleUrls: ['./salaespera.component.css']
})
export class SalaesperaComponent implements OnInit {
  public parametros_url: any;
  consultas_list: any = []; 
  consultas: any = []; 
  consultaOndemand: any ={};

  textoBoton: string = "";

  private intervalId: any; // Guarda el ID del intervalo para limpiarlo después


  tiempoEspera: any = {
    consulta: {},
    data: {
      horaPrimerPaciente: null,
      minutes: null,
      nroMedicos: null,
      posicion: null,
      tiempoEspera: null,
      tiempoEsperaTotal: null,
      totalPacientes: null
    }
  };
  
  constructor(
    public _usuarioService: UsuarioService,
    private http: HttpClient, 
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _medicosServices: MedicosService,
    private _fichaMServices: FichaMedicaService,
    private scheduleService: ScheduleService,
        private cdRef: ChangeDetectorRef,
            private ondemandSocketService: OndemandSocketService,
        
    
  ) {


   }

  usuario: any; // Usuario logeado


  ngOnDestroy(): void {

    if (this.intervalId && this.tiempoEspera.onWaitlist == true) {
      clearInterval(this.intervalId);
    }
  }

  ngOnInit(): void {
    this.getConsultas();
    this.usuario = new EncriptacionService().getUserInfo()

    if(this.usuario.typ_id ==2){
      this.postListUsersWaitList();
      this.ondemandSocketService.onDoctorDisponible().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
      this.ondemandSocketService.onDoctorNoDisponible().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.postListUsersWaitList();
      });
    }
  }

  postListUsersWaitList() {
    this.scheduleService.postListUsersWaitList(this.usuario._id, this.usuario.typ_id)
      .then((response: any) => {
        // console.log('Respuesta del servicio:', response);
        this.tiempoEspera = response;
        this.consultaOndemand = response.consulta || {};
        if(this.consultaOndemand.sta_id == 114 || this.consultaOndemand.sta_id == 120){
          this.textoBoton = "Ir a la fila de espera"; 
        }else if(this.consultaOndemand.sta_id == 116){
          this.textoBoton = "Ir a la sala de espera";
        }
        this.cdRef.detectChanges();
      })
      .catch((error: any) => {
        console.error('Error al obtener la lista de espera:', error);
      });
  }
  getConsultas() {
    this._fichaMServices.getListarConsultas()
        .then((data: any) => {
            this.consultas_list = data;

            if (!this.consultas_list.consultas || !Array.isArray(this.consultas_list.consultas)) {
                console.warn("⚠ No hay consultas disponibles.");
                this.consultas = [];
                return;
            }

            const fechaHoy = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');

            // 🔥 Filtramos solo las consultas de hoy y que NO sean onDemand
            this.consultas = this.consultas_list.consultas
                .filter(consulta => 
                    consulta.fecha_consulta.substring(0, 10) === fechaHoy
                )
                .map(consulta => ({
                    ...consulta,
                    fecha_consulta: new Date(consulta.fecha_consulta.substr(0, 10).replaceAll('-', '/'))
                }));

            // console.log("📋 Consultas filtradas:", this.consultas);
        })
        .catch(error => {
            console.error("❌ Error al obtener las consultas:", error);
            this.consultas = [];
        });
}


  unirseReunionPaciente(item){
    //console.log(item);
    // var resta_minutos = this.obtenerResta(item.hora);
    // var fecha_sistema = new Date();
    // //console.log("Fecha actual: " + fecha_sistema);

    // const fecha = formatDate(fecha_sistema, 'yyyy-MM-dd', 'en-US');

    // //console.log(fecha);

    // //console.log(item.fecha_consulta.substring(0,10));

    // if (item.fecha_consulta.substring(0,10)!=fecha.toString()) { 

    //   Swal.fire({
    //     icon: 'info',
    //     title: 'Consulta en más días.',
    //     text: 'Aún faltan días para acceder a la consulta...',
    //     timer: 5000
    //   })
    // }else if (resta_minutos > 60) {

    //   Swal.fire({
    //     icon: 'info',
    //     title: 'Fuera de horario.',
    //     text: 'Aún falta para acceder a la consulta...',
    //     timer: 5000
    //   })
      
    // } else if (resta_minutos < -60) {
    //   Swal.fire({
    //     icon: 'info',
    //     title: 'Fuera de horario.',
    //     text: 'El tiempo para acceder a la consulta ya ha terminado...',
    //     timer: 5000
    //   })

    // } else
    // {
      var url = "salaespera/"+item.zoo_mee_room_id+"/"+item.id_consulta+"/"+item.med_con_id;
      this.router.navigate([url]);

    // }


   }

   unirseConsultaOndemand() {
    if (this.consultaOndemand && this.consultaOndemand.tel_doc_od_id) {
      let url = `fila-ondemand/${this.consultaOndemand.tel_doc_od_id}/${this.consultaOndemand.tel_doc_od_id}`;
      this.router.navigate([url]);
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Consulta no disponible',
        text: 'No hay una consulta ondemand disponible en este momento.',
        timer: 3000
      });
    }
  }



   unirseReunionDoctor(item)
   {
     //console.log(item);

    //  var resta_minutos = this.obtenerResta(item.hora);
    //  var fecha_sistema = new Date();
    //  //console.log("Fecha actual: " + fecha_sistema);
     // //console.log(fecha_sistema.().toString());
     // //console.log(fecha_sistema.getMonth().toString());
     // //console.log(fecha_sistema.getDay().toString());
    //  const fecha = formatDate(fecha_sistema, 'yyyy-MM-dd', 'en-US');
 
    //  //console.log(fecha);
 
    //  //console.log(item.fecha_consulta.substring(0,10));
 
    //  if (item.fecha_consulta.substring(0,10)!=fecha.toString()) { 
 
    //    Swal.fire({
    //      icon: 'info',
    //      title: 'Consulta en más días.',
    //      text: 'Aún faltan días para acceder a la consulta...',
    //      timer: 5000
    //    })
    //  }
    //  else if (resta_minutos > 60) {

    //    Swal.fire({
    //      icon: 'info',
    //      title: 'Fuera de horario.',
    //      text: 'Aún falta para acceder a la consulta...',
    //      timer: 5000
    //    })
       
    //  }
    //  else if (resta_minutos < -60) {
    //    Swal.fire({
    //      icon: 'info',
    //      title: 'Fuera de horario.',
    //      text: 'El tiempo para acceder a la consulta ya ha terminado...',
    //      timer: 5000
    //    })

    //  } else
    //  {
      //var url = "zoom/"+item.zoo_mee_room_id+"/"+item.zoo_acc_email+"/"+1+"/"+item.email_doctor;
      var url = "videoconsulta/"+item.id_consulta;
      this.router.navigate([url]);
       
    // }

 
   }
   unirseReunion()
   {
    Swal.fire({
      icon: 'info',
      title: 'Consulta en más días.',
      text: 'Aún faltan días para acceder a la consulta...',
      timer: 5000
    })
 
  }


  ConfirmarAsistencia(item) { 
    this._medicosServices.postUpdateSheduleState(item.id_consulta)
      .then(result => { 
        setTimeout(() => window.location.reload(), 100);
      })
      .catch(error => { 
        console.log(error);
      })
  }
  
  obtenerResta(hora)
  {

    var fecha = new Date(Date.now());
    var minutos = fecha.getHours() * 60 + fecha.getMinutes();
    var minutos_consulta = parseInt(hora.substr(0, 2)) * 60 + parseInt(hora.substr(3, 2));
    var diferencia = minutos_consulta - minutos;
    //console.log("Diferencia "+diferencia);
    return diferencia;
  }
  
  showError(err){
    //console.log(err);
    switch (err.status) {
      case 401: //Autenticación: servidor no recive el token
        Swal.fire({
          icon: 'error',
          title: 'Favor reingresar',
          text: '401 - Error de autenticación',
          timer: 2000
        }) // router.navigate ?
        // setTimeout(() => router.navigate(['login']), 2000);
        //setTimeout(() => this._usuarioService.logout(), 2000);
        break;

      case 403: //Autenticación, token expirado
        Swal.fire({
          icon: 'error',
          title: 'Favor reingresar',
          text: '403 - Código de autenticación expirado',
          timer: 2000
        })
        // setTimeout(() => router.navigate(['login']), 2000);
        setTimeout(() => this._usuarioService.logout(), 2000);
        break;
      // case 404: //Not Found
      //   //console.log(err.message);
      //   break;

      case 500: // Error entre servidor - BD, problemas de query, etc.
        //console.log(err.error);
        Swal.fire({
          icon: 'error',
          title: '500 - Error interno',  
          text: err.error.detail,
        })
        break;

      default:
        Swal.fire({
          icon: 'error',
          title: 'Contactar a TI',  
          text: 'Problemas de conexión (default)',
        })
        break;
    }
  }


}
